import apiClient from "./axios"

export const downloadAndOpenFile = async ({
  url,
  params = {},
  method = "get",
  mimeType = "application/pdf",
  openInNewTab = true,
  filename = null,
  onStart,
  onEnd,
}) => {
  try {
    onStart?.()

    const response = await apiClient({
      url,
      method,
      params,
      responseType: "blob",
    })

    const file = new Blob([response.data], { type: mimeType })
    const fileURL = URL.createObjectURL(file)

    if (openInNewTab) {
      window.open(fileURL, "_blank")
    } else {
      const link = document.createElement("a")
      link.href = fileURL
      link.download = filename || "download"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    setTimeout(() => URL.revokeObjectURL(fileURL), 1000)
  } catch (error) {
    console.error("File download/open failed:", error)
    throw error
  } finally {
    onEnd?.()
  }
}
